import { readonly, ref } from "vue"

export const useAnswers = (size) => {
  const state = ref(Array(size))

  const set = (value, index) => {
    state.value[index] = (value)
  }

  return { answers: readonly(state), set }
}